export default __webpack_public_path__ + "images/home.24044fc135e5a4ee5e2c71d048db7b11.svg";